import * as zoid from 'zoid';
import { createLogger } from "@888webteam/logger-core";
import { Utils } from './utils';

let zoidComponent = null;

export function zoidCreate(context) {
    if (zoidComponent === null) {
        let url = `${__webpack_public_path__}BankIdAuthenticator/?mode=${context.mode}&cdnHost=${encodeURIComponent(__webpack_public_path_cdn__)}`;

        if (typeof context.brandId === "number") {
            url += `&brandId=${context.brandId}`;
        }

        if (typeof context.subBrandId === "number") {
            url += `&subBrandId=${context.subBrandId}`;
        }

        if (typeof context.clientProductPackage === "number") {
            url += `&clientProductPackage=${context.clientProductPackage}`;
        }

        let logger = createLogger("Zoid");

        zoidComponent = zoid.create({
            tag: 'bankid-authenticator',
            url: url,
            dimensions: {
                width: '100%',
                height: '100%'
            },
            logger: {
                debug: logger.log.bind(logger),
                info: logger.log.bind(logger),
                warn: logger.warn.bind(logger),
                error: logger.error.bind(logger)
            }
        });
    }

    return zoidComponent;
}